(function () {
  'use strict';

  var DE_DAYS   = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
  var DE_MONTHS = ['Jan.', 'Feb.', 'Mrz.', 'Apr.', 'Mai', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Okt.', 'Nov.', 'Dez.'];

  function init() {
    document.querySelectorAll('.period-urgency').forEach(setupUrgency);
  }

  function setupUrgency(el) {
    var productId    = el.dataset.productId;
    var inventory    = parseInt(el.dataset.inventory, 10) || 0;
    var managed      = el.dataset.inventoryManaged;
    var cutoffH      = parseInt(el.dataset.cutoffHour, 10);
    var cutoffM      = parseInt(el.dataset.cutoffMinute, 10);
    var delayDays    = parseInt(el.dataset.delayDays, 10) || 0;
    var deliveryDays = parseInt(el.dataset.deliveryDays, 10) || 2;
    var threshold    = parseInt(el.dataset.stockThreshold, 10) || 800;
    var delayNote    = el.dataset.delayNote || '';

    setupStock(el, inventory, managed, threshold);
    setupTimeline(el, cutoffH, cutoffM, delayDays, deliveryDays, delayNote);
  }

  // ── Stock ─────────────────────────────────────────────────────────────────

  function setupStock(el, inventory, managed, threshold) {
    if (managed !== 'shopify' || inventory < 0 || inventory >= threshold) return;
    var stockEl = el.querySelector('.period-urgency__stock');
    var textEl  = el.querySelector('.period-urgency__stock-text');
    if (!stockEl || !textEl) return;
    textEl.textContent = 'Nur noch ' + inventory + ' verfügbar';
    stockEl.removeAttribute('hidden');
  }

  // Hinweis: Der frühere Zufalls-Cart-Counter ("N× heute bestellt") ist am
  // 26.08.2026 ersatzlos entfernt worden (B-056). Die wahre Aussage
  // ("War in den letzten 12 Monaten mehrmals ausverkauft") wird serverseitig
  // in product-urgency-row.liquid gerendert und braucht kein JS.

  // ── Timezone helpers ───────────────────────────────────────────────────────

  function getZurich() {
    var fmt = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Europe/Zurich',
      weekday: 'short', year: 'numeric', month: '2-digit',
      day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false
    });
    var p = {};
    fmt.formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    var wdMap = { Sun:0, Mon:1, Tue:2, Wed:3, Thu:4, Fri:5, Sat:6 };
    var h = parseInt(p.hour, 10);
    return {
      wd: wdMap[p.weekday],
      y:  parseInt(p.year, 10),
      mo: parseInt(p.month, 10) - 1,
      d:  parseInt(p.day, 10),
      h:  h === 24 ? 0 : h,
      m:  parseInt(p.minute, 10)
    };
  }

  function addWorkingDays(y, mo, d, n) {
    var date = new Date(y, mo, d);
    var added = 0;
    while (added < n) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() !== 0 && date.getDay() !== 6) added++;
    }
    return { y: date.getFullYear(), mo: date.getMonth(), d: date.getDate(), wd: date.getDay() };
  }

  function formatDate(y, mo, d, wd) {
    return DE_DAYS[wd] + ', ' + d + '. ' + DE_MONTHS[mo];
  }

  // ── Timeline ───────────────────────────────────────────────────────────────

  function setupTimeline(el, cutoffH, cutoffM, delayDays, deliveryDays, delayNote) {
    updateTimeline(el, cutoffH, cutoffM, delayDays, deliveryDays, delayNote);
    setInterval(function () {
      updateTimeline(el, cutoffH, cutoffM, delayDays, deliveryDays, delayNote);
    }, 60000);
  }

  function updateTimeline(el, cutoffH, cutoffM, delayDays, deliveryDays, delayNote) {
    var z = getZurich();
    var isWeekend    = z.wd === 0 || z.wd === 6;
    var isAfterCutoff = z.h > cutoffH || (z.h === cutoffH && z.m >= cutoffM);
    var todayIsShipping = !isWeekend && !isAfterCutoff && delayDays === 0;

    // ── Compute ship date ──
    var daysToNextWorkday = 0;
    if (!isWeekend && !isAfterCutoff) {
      daysToNextWorkday = 0;
    } else if (z.wd === 5 && isAfterCutoff) {
      daysToNextWorkday = 3;
    } else if (z.wd === 6) {
      daysToNextWorkday = 2;
    } else if (z.wd === 0) {
      daysToNextWorkday = 1;
    } else {
      daysToNextWorkday = 1;
    }

    var baseDate = new Date(z.y, z.mo, z.d + daysToNextWorkday);
    var shipObj  = delayDays > 0
      ? addWorkingDays(baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate(), delayDays)
      : { y: baseDate.getFullYear(), mo: baseDate.getMonth(), d: baseDate.getDate(), wd: baseDate.getDay() };

    // ── Compute delivery date ──
    var delivObj = addWorkingDays(shipObj.y, shipObj.mo, shipObj.d, deliveryDays);

    console.log(
      '[PERIOD Versand] Zürich:', z.y+'-'+(z.mo+1)+'-'+z.d, z.h+':'+(z.m<10?'0':'')+z.m,
      '| Versand:', shipObj.y+'-'+(shipObj.mo+1)+'-'+shipObj.d+'('+DE_DAYS[shipObj.wd]+')',
      '| Lieferung:', delivObj.y+'-'+(delivObj.mo+1)+'-'+delivObj.d+'('+DE_DAYS[delivObj.wd]+')'
    );

    var shipIsToday = shipObj.y === z.y && shipObj.mo === z.mo && shipObj.d === z.d;

    // ── Render order step ──
    var orderDateEl    = el.querySelector('.period-urgency__step--order .period-urgency__step-date');
    var countdownEl    = el.querySelector('.period-urgency__step-countdown');

    if (orderDateEl) orderDateEl.textContent = 'Heute';

    if (countdownEl) {
      if (todayIsShipping) {
        var totalNow    = z.h * 60 + z.m;
        var totalCutoff = cutoffH * 60 + cutoffM;
        var diffMin     = totalCutoff - totalNow;
        var hh = Math.floor(diffMin / 60);
        var mm = diffMin % 60;
        countdownEl.textContent = 'noch ' + hh + 'h ' + mm + 'm';
        countdownEl.removeAttribute('hidden');
      } else {
        countdownEl.setAttribute('hidden', '');
      }
    }

    // ── Render ship step ──
    var shipDateEl = el.querySelector('.period-urgency__step--ship .period-urgency__step-date');
    if (shipDateEl) {
      shipDateEl.textContent = shipIsToday ? 'Heute' : formatDate(shipObj.y, shipObj.mo, shipObj.d, shipObj.wd);
    }

    // ── Render delivery step ──
    var delivDateEl = el.querySelector('.period-urgency__step--deliver .period-urgency__step-date');
    if (delivDateEl) {
      delivDateEl.textContent = formatDate(delivObj.y, delivObj.mo, delivObj.d, delivObj.wd);
    }

    // ── Delay note ──
    var noteEl = el.querySelector('.period-urgency__note');
    if (noteEl) {
      if (delayDays > 0 && delayNote) {
        noteEl.textContent = delayNote;
        noteEl.removeAttribute('hidden');
      } else {
        noteEl.setAttribute('hidden', '');
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
